import 'whatwg-fetch' // fetch polyfill

import Cart from 'components/payment/Cart';
import CheckoutConsumer, { CheckoutProvider } from 'components/payment/Context';
import Payment from 'components/payment/Payment/Version2';
import ProductSelection from 'components/payment/ProductSelection';
import PromoCode from 'components/payment/PromoCode';
import {
	get,isEmpty
} from 'lodash';
import React, {
	useEffect, useRef, useState
} from 'react';
import {
	Element,scroller
} from 'react-scroll';
import stickybits from 'stickybits';

import {
	IDtoNameMap,
	OTCMap,
} from '../../../content/checkout';
import { SectionWrapper } from '../components/Payment/styles';
import Shipping from '../components/Shipping';
import Signup from '../components/Signup';
import Disclaimer from './Disclaimer';
import {
	Button,
	CheckoutWrapper,
	OrderSummary,
	ProductImage,
	ProductWrapper,
	Sections,
	Spacer,
	SubmitContainer,
	TextWrapper,
} from './styles';

const App = (props) => {
	const [firstStep, setFirstStep] = useState(true);
	const [section, setSection] = useState(Object.keys(props.patient).length !== 0 ? 1 : 0);
	const [patient, setPatient] = useState(props.patient);
	const [firstname, setFirstname] = useState('');
	const [lastname, setLastname] = useState('');
	const csrfToken = get(props,
		'client_token');

	const btnContainerRef = useRef();
	const mobileBtnContainerRef = useRef();

	useEffect(() => {
		stickybits('.cart-container',
			{ stickyBitStickyOffset: 150 });
	},
	[]);

	const scrollToSection = (section) => {
		let offset = -500;
		if (section === 'payment') {
			offset = -100;
		}
		scroller.scrollTo(section,
			{
				duration: 500,
				delay: 100,
				smooth: true,
				offset,
			});
	}

	if (firstStep) {
		return (
			<CheckoutProvider {...props}>
				<CheckoutConsumer>
					{({
						dispatcher, state,
					}) => (
						<CheckoutWrapper data-cy={'CheckoutWrapper'}>
							<div className="main-container">
								<div className="content-container mobile-no-header">
									<div className="inner-container">
										<div className="width-container small">
											<div className="page-content">
												<Spacer />
												<ProductSelection
													otcCheckout={true}
													cart={state.cart}
													products={props.otc_product_options}
													changeOption={dispatcher.changeOption}
													removeProduct={dispatcher.removeFromCart}
													addProduct={dispatcher.addToCart}
													clientToken={csrfToken}
													otcProducts={props.otc_product_options}
													otcTypeInCart={props.otcTypeInCart}
												/>
												<OrderSummary data-cy={'OrderSummary'}>
													<h1>Order Summary</h1>
													<hr />
													{Object.keys(state.cart.products).length !== 0
														? <div style={{ width: '100%' }}>
															<Cart
																state={state}
																dispatcher={dispatcher}
																showShipping
																medCheckout={true}
															/>
														</div>
														:
														<div style={{ width: '100%' }}>No Products in Cart</div>
													}
													<SubmitContainer data-cy={'SubmitContainer'}>
														<Button onClick={() => setFirstStep(false)}>
                            Proceed to checkout
														</Button>
													</SubmitContainer>
												</OrderSummary>
											</div>
										</div>
									</div>
								</div>
							</div>
						</CheckoutWrapper>
					)}
				</CheckoutConsumer>
			</CheckoutProvider>
		);
	}
	return (
		<CheckoutProvider {...props}>
			<CheckoutConsumer>
				{({
					dispatcher, state,
				}) => { return(
					<CheckoutWrapper stage2={true} data-cy={'CheckoutWrapper'}>
						<div className="main-container">
							<div className="content-container mobile-no-header">
								<div className="inner-container">
									<div className="width-container small">
										<div className="page-content">
											<Spacer />
											<Sections>
												<Signup
													scrollToSection={scrollToSection}
													setSection={setSection}
													activeSection={section}
													section={0}
													state={state}
													token={props.client_token}
													setPatient={setPatient}
													setFirstname={setFirstname}
													setLastname={setLastname}
													patient={patient}
												/>
												<Element className="scroll-wrapper" name="shipping">
													<Shipping
														patient={patient}
														firstname={firstname}
														lastname={lastname}
														scrollToSection={scrollToSection}
														setSection={setSection}
														activeSection={section}
														section={1}
														state={state}
														token={props.client_token}
													/>
												</Element>
												<Element className="scroll-wrapper" name="payment">
													<SectionWrapper activeSection={section} section={2}>
														<h3>3 of 3</h3>
														<h1>Payment & Billing</h1>
														<div className="content">
															<Payment
																{...props}
																{...state}
																{...dispatcher}
																updateDefaultPaymentMethod={
																	dispatcher.updateDefaultPaymentMethod
																}
																nextStepUrl={props.stepNext} // server determines whether needs to go to shipping page first.
																btnContainer={btnContainerRef}
																mobileBtnContainer={mobileBtnContainerRef}
																buttonPortal
																otcCheckout={true}
																patient={patient}
															/>
															{Object.keys(state.cart.products).length !== 0 && (
																<PromoCode
																	state={state}
																	dispatcher={dispatcher}
																	medCheckout={true}
																	otcCheckout={true}
																/>
															)}
															<SubmitContainer data-cy={'SubmitContainer'}>
																<div
																	ref={btnContainerRef}
																	className="submit-button"
																	data-cy={'submit-button'}
																/>
																<Disclaimer cart={state.cart} />
															</SubmitContainer>
														</div>
													</SectionWrapper>
												</Element>
											</Sections>
											<OrderSummary data-cy={'OrderSummary'}>
												<h1>Order Summary</h1>
												<hr />
												{Object.entries(state.cart.products).map((product) => {
													let otcInfo = OTCMap[IDtoNameMap[product[1].otc_id]]
													return (
														<ProductWrapper>
															{otcInfo.imgSrc && <ProductImage src={otcInfo.imgSrc}/>}
															<TextWrapper>
																<h1>{otcInfo.name}</h1>
																<h2>Qty: 1</h2>
																<h2 className="size">{otcInfo.size}</h2>
															</TextWrapper>
														</ProductWrapper>
													);
												})}
												{Object.keys(state.cart.products).length !== 0
													? <div style={{ width: '100%' }}>
														<Cart
															state={state}
															dispatcher={dispatcher}
															showShipping
															medCheckout={true}
														/>
													</div>
													:
													<div style={{ width: '100%' }}>No Products in Cart</div>
												}
											</OrderSummary>
										</div>
									</div>
								</div>
							</div>
						</div>
					</CheckoutWrapper>
				)}}
			</CheckoutConsumer>
		</CheckoutProvider>
	);
};

export default App;
